import { Box, Loader } from '@mantine/core'

import { cn } from 'src/utils'

const buttonVariants = {
  primary:
    'bg-doubleNickel-brand-500 text-white hover:bg-doubleNickel-brand-400',
  secondary:
    'bg-doubleNickel-gray-100 text-doubleNickel-gray-700 hover:bg-doubleNickel-gray-200',
  error: 'bg-doubleNickel-error-500 text-white hover:bg-doubleNickel-error-400',
  success:
    'bg-doubleNickel-success-500 text-white hover:bg-doubleNickel-success-400',
  warning:
    'bg-doubleNickel-warning-500 text-white hover:bg-doubleNickel-warning-400',
  transparent:
    'bg-transparent text-doubleNickel-gray-700 hover:bg-doubleNickel-gray-200',
  outline:
    'border border-doubleNickel-gray-300 text-doubleNickel-gray-700 hover:bg-doubleNickel-gray-200',
}

const DNButton = ({
  loading = false,
  className = '',
  children,
  variant = 'outline',
  ...props
}) => {
  return (
    <Box
      className={cn(
        'flex max-h-9 cursor-pointer flex-row items-center justify-center gap-3 text-nowrap rounded p-2 text-xs font-medium',
        buttonVariants[variant],
        className
      )}
      {...props}
    >
      {loading ? <Loader size={16} color="white" /> : children}
    </Box>
  )
}

export default DNButton
